
export class OrderFilter {
    accMonthId: number;
    administrationIds: Array<number>;
    employeeIds: Array<number>;
    companyIds: Array<number>;
    costCenterIds: Array<number>;
    partnerIds: Array<number>;
    filter: string;
}
